export const DEFAULT_MAX_FILE_SIZE = 10 * 1024 * 1024 // 10 MB
export const MMS_IMAGE_FILE_LIMIT = 3_670_016 // 3.5 MB
export const MMS_FILE_LIMIT = 537_600 // 525 KB
export const SMS_FILE_LIMIT = 10_485_760 // 10 MB
export const WA_IMAGE_FILE_LIMIT = 5_242_880 // 5 MB
export const WA_VIDEO_AUDIO_FILE_LIMIT = 16_777_216 // 16 MB
export const WA_DOC_FILE_LIMIT = 104_857_600 // 100 MB
export const FB_IMAGE_FILE_LIMIT = 8_388_608 // 8 MB
export const FB_VIDEO_AUDIO_FILE_LIMIT = 26_214_400 // 25 MB
export const FB_DOC_FILE_LIMIT = 26_214_400 // 25 MB

export type MessagesSendFormServiceSubmitConfig = {
  labelId: string | null
}

export interface MessagesAttachmentFileFormScheme {
  file: File | null
}
